// Muted looping previews for uploaded videos inside Keo tiles/cards
// (video[data-keo-preview]). Each preview only plays while it's on screen,
// so a rail of eight reels doesn't decode eight videos at once, and nothing
// autoplays for visitors who prefer reduced motion.
(function () {
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function load(video) {
    if (!video.src && video.dataset.src) video.src = video.dataset.src;
  }

  function init(root) {
    var videos = (root || document).querySelectorAll('video[data-keo-preview]:not([data-keo-preview-ready])');
    if (!videos.length || reduceMotion) return;
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var video = entry.target;
        if (entry.isIntersecting) {
          load(video);
          var p = video.play();
          if (p && p.catch) p.catch(function () {});
        } else {
          video.pause();
        }
      });
    }, { threshold: 0.25 });
    videos.forEach(function (video) {
      video.setAttribute('data-keo-preview-ready', '');
      video.muted = true;
      observer.observe(video);
    });
  }

  window.keoInitVideoPreviews = init;
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  // Re-run when sections are added/edited in the theme editor.
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
